export const setDocumentLanguage = (lang: string): void => {
  $('html').attr('lang', lang);
};
